import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';
import { SlidersUIProvider } from './SlidersContextProvider';

const SlidersList = React.lazy(() => import('./Sliders'));

function Sliders(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست اسلایدرها</PageTitle>
        <Button as={Link} type="anchor" to="/sliders/new">
          ساخت اسلایدر
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <SlidersUIProvider>
          <SlidersList {...props} />
        </SlidersUIProvider>
      </Suspense>
    </Page>
  );
}

export default Sliders;
